var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.getuseraccess},on:{"change":function($event){return _vm.updatecheckbox($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }